import { FC } from "react";
import { useTranslation } from "react-i18next";

import { CourseSchedulesPreviewContent } from "@ryde/controls";
import {
  ICourseSchedulesPreviewDrawerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { CommonDefaultDrawer } from "../common-default-drawer";
import { BaseDrawer, FormFooter } from "../drawer";

export const CourseSchedulesPreviewDrawer: FC<
  ICourseSchedulesPreviewDrawerProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber, schedules, title }) => {
  const { t } = useTranslation();

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <CommonDefaultDrawer
        title={title || t("rideProduction.courseSchedulesPreviewTitle")}
        onCloseDrawer={onCloseDrawer}
        Footer={
          <FormFooter
            cancelLabel={t("general.CLOSE")}
            onCancelClick={onCloseDrawer}
          />
        }
      >
        <CourseSchedulesPreviewContent schedules={schedules} />
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
